import React, { useState } from 'react';

import { useQuery } from 'react-query';
import { useRouter } from 'next/router';

import { CourseFeedbackSummary, LectureFeedbackSummary } from 'services/core';

import FeedbackButton from './feedbackButton/FeedbackButton';

import StarRating from 'assets/icons/star-rating.svg';
import EmptyState from 'assets/icons/empty-reviews-icon.svg?url';

import classes from './ContentFeedbackSummary.module.scss';

const ContentFeedbackSummary = ({ contentType, hasEmptyState }) => {
	const router = useRouter();
	const [courseId] = useState(router?.query?.slug[0]);

	const { data, isLoading, error, refetch } = useQuery(
		['content-feedback', contentType, courseId],
		() =>
			contentType === 'course' ? CourseFeedbackSummary(courseId) : LectureFeedbackSummary(courseId),
		{
			cacheTime: 20 * 60 * 1000,
			staleTime: 20 * 60 * 1000
		}
	);
	return (
		<>
			{(hasEmptyState || data?.data?.rate_count !== 0) && (
				<h3 className={`${classes['content-feedback-summary-header']}`}>Learner Reviews</h3>
			)}
			{!isLoading && data && !error && (
				<div
					className={`d-flex flex-row flex-wrap align-items-center ${
						data?.data?.rate_count !== 0 ? 'justify-content-base' : 'justify-content-center'
					}`}>
					{data.data.rate_count !== 0 ? (
						<div
							className={`${classes['content-feedback-summary']} d-flex flex-row col-12 col-lg-5`}>
							<div className={`${classes['summary-number']} d-felx flex-column`}>
								<div className="d-flex flex-row align-items-center">
									<StarRating data-testid="star-rating" />
									<h3>{data.data.rate_average}</h3>
								</div>
								<h6>Based on</h6>
								<p>{data.data.rate_count} reviews</p>
							</div>
							<div
								className={`${classes['percent-summary']} d-flex flex-column justify-content-between`}>
								{data?.data?.rates &&
									Object.keys(data.data.rates)
										.reverse()
										.map((key) => (
											<div key={key} className={`d-flex flex-row align-items-center`}>
												<span>{key} Star</span>
												<div>
													<div
														style={{
															width: `${+data.data.rates[key]}%`
														}}></div>
												</div>
												<span>{+data.data.rates[key]}%</span>
											</div>
										))}
							</div>
						</div>
					) : (
						hasEmptyState && (
							<div
								className={`${classes['empty-state']} d-flex flex-column flex-wrap w-100 align-items-center justify-content-center gap-3 my-4`}>
								<img src={EmptyState} alt="no-feedback" data-testid="empty-state" />
								<p>
									There are no reviews yet. Be the first to give feedback and help your fellow
									learners discover this content!
								</p>
							</div>
						)
					)}
					{data.data.allowed_sending && (hasEmptyState || data.data.rate_count !== 0) && (
						<div className={`col-12 col-lg-7 my-4`}>
							<FeedbackButton
								contentID={courseId}
								contentType={contentType}
								refetchFeedbackSummary={refetch}
							/>
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default React.memo(ContentFeedbackSummary);
